import React, { 
    Component,
    PropTypes,
} from 'react'
import prefix from 'react-prefixer'

class GradientBackground extends React.Component{
  constructor(props){
    super(props)
    this.state = {
      step: 0,
      colorIndices: [0,1,2,3]
    }
  }

  componentWillMount(){
    this.intervals = []
  }

  setInterval(){
    this.intervals.push(setInterval.apply(null, arguments))
  }

  componentWillUnmount(){
    this.clearInterval()
  }

  componentDidMount(){
    this.startInterval()
  }

  startInterval(){
    let intervalId = setInterval(this.updateGradient.bind(this),10)
    this.setState({intervalId})
  }

  clearInterval(){
    clearInterval(this.state.intervalId)
  }

  updateGradient(){
    var colors = new Array(
      [62,35,255],
      [60,255,60],
      [255,35,98],
      [45,175,230],
      [255,0,255],
      [255,128,0])

    let {step, colorIndices} = this.state

    var gradientSpeed = 0.002
    
    var c0_0 = colors[colorIndices[0]]
    var c0_1 = colors[colorIndices[1]]
    var c1_0 = colors[colorIndices[2]]
    var c1_1 = colors[colorIndices[3]]

    var istep = 1 - step
    var r1 = Math.round(istep * c0_0[0] + step * c0_1[0])
    var g1 = Math.round(istep * c0_0[1] + step * c0_1[1])
    var b1 = Math.round(istep * c0_0[2] + step * c0_1[2])
    var color1 = 'rgb('+r1+','+g1+','+b1+')'

    var r2 = Math.round(istep * c1_0[0] + step * c1_1[0])
    var g2 = Math.round(istep * c1_0[1] + step * c1_1[1])
    var b2 = Math.round(istep * c1_0[2] + step * c1_1[2])
    var color2 = 'rgb('+r2+','+g2+','+b2+')'

    step += gradientSpeed
    if ( step >= 1 )
    {
      step %= 1
      colorIndices[0] = colorIndices[1]
      colorIndices[2] = colorIndices[3]
      
      colorIndices[1] = ( colorIndices[1] + Math.floor( 1 + Math.random() * (colors.length - 1))) % colors.length
      colorIndices[3] = ( colorIndices[3] + Math.floor( 1 + Math.random() * (colors.length - 1))) % colors.length
    }

    this.setState({
      color1,
      color2,
      step,
      colorIndices
    })
  }

  render() {

    let {color1, color2} = this.state
    let style = prefix({
      background: `linear-gradient(60deg, ${color1}, ${color2})`
    })
    return <div 
      className='background' 
      style={style}>
      
    </div>
  }
}
module.exports = GradientBackground










/** WEBPACK FOOTER **
 ** assets/javascripts/introduction/gradient_background.js
 **/